import {useEffect, useState} from 'react'
import styled, {css} from 'styled-components'

import login1_broad from '@product-web/images/login/broad/log-in-1-card.jpg'
import login2_broad from '@product-web/images/login/broad/log-in-2-boot.jpg'
import login3_broad from '@product-web/images/login/broad/log-in-3-collaboration.jpg'
import login4_broad from '@product-web/images/login/broad/log-in-4-remote.jpg'
import login5_broad from '@product-web/images/login/broad/log-in-5-lift.jpg'
import login6_broad from '@product-web/images/login/broad/log-in-6-pingpong.jpg'
import login7_broad from '@product-web/images/login/broad/log-in-7-plane.jpg'
import login8_broad from '@product-web/images/login/broad/log-in-8-paper.jpg'
import login9_broad from '@product-web/images/login/broad/log-in-9-strategies.jpg'
import login10_broad from '@product-web/images/login/broad/log-in-10-winking.jpg'
import login11_broad from '@product-web/images/login/broad/log-in-11-teamwork.jpg'
import login12_broad from '@product-web/images/login/broad/log-in-12-stretching.jpg'
import login13_broad from '@product-web/images/login/broad/log-in-13-ball.jpg'
import login14_broad from '@product-web/images/login/broad/log-in-14-laptop.jpg'
import login15_broad from '@product-web/images/login/broad/log-in-15-mobile.jpg'
import login16_broad from '@product-web/images/login/broad/log-in-16-receipt.jpg'
import login1_narrow from '@product-web/images/login/narrow/log-in-1-card.jpg'
import login2_narrow from '@product-web/images/login/narrow/log-in-2-boot.jpg'
import login3_narrow from '@product-web/images/login/narrow/log-in-3-collaboration.jpg'
import login4_narrow from '@product-web/images/login/narrow/log-in-4-remote.jpg'
import login5_narrow from '@product-web/images/login/narrow/log-in-5-lift.jpg'
import login6_narrow from '@product-web/images/login/narrow/log-in-6-pingpong.jpg'
import login7_narrow from '@product-web/images/login/narrow/log-in-7-plane.jpg'
import login8_narrow from '@product-web/images/login/narrow/log-in-8-paper.jpg'
import login9_narrow from '@product-web/images/login/narrow/log-in-9-strategies.jpg'
import login10_narrow from '@product-web/images/login/narrow/log-in-10-winking.jpg'
import login11_narrow from '@product-web/images/login/narrow/log-in-11-teamwork.jpg'
import login12_narrow from '@product-web/images/login/narrow/log-in-12-stretching.jpg'
import login13_narrow from '@product-web/images/login/narrow/log-in-13-ball.jpg'
import login14_narrow from '@product-web/images/login/narrow/log-in-14-laptop.jpg'
import login15_narrow from '@product-web/images/login/narrow/log-in-15-mobile.jpg'
import login16_narrow from '@product-web/images/login/narrow/log-in-16-receipt.jpg'
import {breakpoints} from '@product-web/styles/theme'

const images: {broad: typeof login1_broad; narrow: typeof login1_narrow; ratio?: number}[] = [
    {broad: login1_broad, narrow: login1_narrow, ratio: 1},
    {broad: login2_broad, narrow: login2_narrow, ratio: 1.2},
    {broad: login3_broad, narrow: login3_narrow, ratio: 1.4},
    {broad: login4_broad, narrow: login4_narrow, ratio: 1.4},
    {broad: login5_broad, narrow: login5_narrow, ratio: 1.4},
    {broad: login6_broad, narrow: login6_narrow, ratio: 1.2},
    {broad: login7_broad, narrow: login7_narrow, ratio: 1.4},
    {broad: login8_broad, narrow: login8_narrow, ratio: 1.4},
    {broad: login9_broad, narrow: login9_narrow, ratio: 1.8},
    {broad: login10_broad, narrow: login10_narrow, ratio: 1.4},
    {broad: login11_broad, narrow: login11_narrow, ratio: 1.4},
    {broad: login12_broad, narrow: login12_narrow, ratio: 1.4},
    {broad: login13_broad, narrow: login13_narrow, ratio: 1.5},
    {broad: login14_broad, narrow: login14_narrow, ratio: 1.5},
    {broad: login15_broad, narrow: login15_narrow, ratio: 1.5},
    {broad: login16_broad, narrow: login16_narrow, ratio: 1.7},
]

export const EmailPhoto = () => {
    const [randomImage, setRandomImage] = useState<number>(-1)
    const [ratio, setRatio] = useState<number>(0)

    useEffect(() => {
        setRandomImage(Math.floor(Math.random() * images.length))

        function updateWindowSize() {
            const width = window.innerWidth
            const height = window.innerHeight
            setRatio(width / height)
        }

        updateWindowSize()
        window.addEventListener('resize', updateWindowSize)

        return () => {
            window.removeEventListener('resize', updateWindowSize)
        }
    }, [])

    const imageSet = images[randomImage]

    const isNarrow = ratio < (imageSet?.ratio ?? 1)

    return imageSet ? (
        <>
            <ColumnImage $visible={isNarrow} $imagePath={imageSet.narrow} />
            <ColumnImage $visible={!isNarrow} $imagePath={imageSet.broad} />
        </>
    ) : null
}

interface ImageProps {
    $imagePath?: string
    $visible: boolean
}

export const ColumnImage = styled.div<ImageProps>`
    align-items: center;
    justify-content: center;
    grid-area: illustration;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url(${({$imagePath}: ImageProps) => ($imagePath ? $imagePath : '')});
    ${({$visible}) =>
        !$visible &&
        css`
            position: absolute;
            left: -9999px;
        `};

    @media (max-width: ${breakpoints.tabletUp}) {
        display: none;
    }

    svg {
        width: 100%;
    }
`
